import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Progress} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
class LoadProgressBar extends Component {
  constructor(props) {
    super(props);
    this.getProgress = this.getProgress.bind(this);
    this.progressTimer = null;
    this.transactionTimer = null;
  }
  componentDidMount() {
    const progressInterval = 30000;
    this.progressTimer = setInterval(() => {
      this.props.getChangePricesStatus();
    }, progressInterval);
  }
  componentWillUnmount() {
    clearInterval(this.progressTimer);
  }
  getProgress() {
    const {updateRecords} = this.props;
    if (updateRecords === 100) {
      this.clearInterval(this.progressTimer);
    }
    return updateRecords;
  }
  render() {
    const progress = this.getProgress();
    const {updatingPrice} = this.props;
    // eslint-disable-next-line max-len
    const labelMessage = 'Actualización de Precios , items procesados '.concat(String(progress.procesedItems).concat(' de '.concat(progress.totalItems)));
    if (updatingPrice === false) {
      this.clearInterval(this.progressTimer);
      return null;
    }
    return (
      // eslint-disable-next-line max-len
      <Progress indicating progress percent={progress.porcentaje} inverted={!progress.porcentaje} label ={labelMessage}/>
      
    );
  }
}
const mapStateToProps = (state) => {
  return {
    'updateRecords': state.partsCatalog.updateRecords,
  };
};
const {getChangePricesStatus} = Actions;
export default connect(mapStateToProps, {
  getChangePricesStatus,
})(LoadProgressBar);
